import React from "react";
import PropTypes from "prop-types";

const ApplicantsEmptyIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "#121212";

  return (
    <svg
      width={width || 40}
      height={height || 40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M25 4.16667V6.66667C25 9.02334 25 10.2017 25.7333 10.9333C26.4633 11.6667 27.6417 11.6667 30 11.6667H32.5"
        stroke={strokeColor}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66663 26.6667V13.3333C6.66663 8.62 6.66663 6.26167 8.13163 4.79834C9.59496 3.33334 11.9533 3.33334 16.6666 3.33334H23.62C24.3 3.33334 24.6416 3.33334 24.9483 3.46C25.2533 3.58667 25.495 3.82667 25.9766 4.31L32.3566 10.69C32.84 11.1733 33.08 11.4133 33.2066 11.72C33.3333 12.025 33.3333 12.3667 33.3333 13.0467V26.6667C33.3333 31.38 33.3333 33.7383 31.8683 35.2017C30.405 36.6667 28.0466 36.6667 23.3333 36.6667H16.6666C11.9533 36.6667 9.59496 36.6667 8.13163 35.2017C6.66663 33.7383 6.66663 31.38 6.66663 26.6667Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 18.3333V23.3333M20 23.3333V28.3333M20 23.3333H12.5M20 23.3333H27.5M15.8333 28.3333H24.1667C25.7383 28.3333 26.5233 28.3333 27.0117 27.845C27.5 27.3567 27.5 26.5717 27.5 25V21.6667C27.5 20.095 27.5 19.31 27.0117 18.8217C26.5233 18.3333 25.7383 18.3333 24.1667 18.3333H15.8333C14.2617 18.3333 13.4767 18.3333 12.9883 18.8217C12.5 19.31 12.5 20.095 12.5 21.6667V25C12.5 26.5717 12.5 27.3567 12.9883 27.845C13.4767 28.3333 14.2617 28.3333 15.8333 28.3333Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ApplicantsEmptyIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ApplicantsEmptyIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default ApplicantsEmptyIcon;
